import { UnderlineInput } from './underline_input';
export const OutsidePage = React.createClass({
    displayName: 'OutsidePage',
    propTypes: {
        backgroundImage: React.PropTypes.string,
    	supportedLangs: React.PropTypes.array,
    	content: React.PropTypes.node,
        mobile: React.PropTypes.bool
    },
    getDefaultProps() {
    	return {
            backgroundImage: Skywatch && Skywatch.backgroundImage ? Skywatch.backgroundImage : '',
            logoImage: Skywatch && Skywatch.logoImage ? Skywatch.logoImage : '',
    		supportedLangs: [
	    		{
	    			tag: 'tw',
	    			name: 'tw'
	    		}, 
	    		{
	    			tag: 'en',
	    			name: 'en'
	    		}
	    	],
            mobile: false,
    		content: ''
    	};
    },
    onLogoClick() {
        $(location).attr('href', 'login');
    },
    onLangClick(tag) {
    	// direct do something here, no need to inject callback function
        var url = $(location).attr('href');
        var uri_data = '';
        if(url.indexOf('#') > 0) {
            uri_data = url.substr(url.indexOf('#'));
            url = url.substr(0, url.indexOf('#'));
        }
        url = url.replace('#', '');
        if(url.substr(url.length-1) == '/') {
            url.substr(0, url.length-1);
        }
        // check for lang keys
        var tokens = url.split('/');
        var current_lang = tokens[tokens.length-2];
        var all_langs = this.props.supportedLangs.map((l) => l.tag);
        
        if(this.props.supportedLangs.map((l) => l.tag).indexOf(current_lang) >= 0) {
            // replace lang key
            tokens[tokens.length-2] = tag;
        } else {
            // insert lang key
            tokens.splice(tokens.length-1, 0, tag);
        }

        url = tokens.join('/') + uri_data;

        $(location).attr('href',url);
    },
    render() {
        var backgroundStyle = {
            backgroundImage: `url(/images/dealer_images/background/${this.props.backgroundImage})`
        };

        var logoStyle = {
            backgroundImage: `url(/api/v2/models/logo)`  
        }
        
    	return (
			<div className="skywatch-outside">
                <div className="outside-background" style={backgroundStyle}/>
                <div className="outside-foreground">
                    {
                        this.props.mobile ? null :
                        <div className="upper-container">
                            {this.props.logoImage == '' ? 
                                null : 
                                <div className="logo-container" style={logoStyle} onClick={this.onLogoClick}/>
                            }

            				<div className="lang-container">
            					{this.props.supportedLangs.map((lang, index) => {
            						return (
            							<div className="lang" onClick={this.onLangClick.bind(null, lang.tag)}>
            								{lang.name} 
            							</div>
            						);
            					})}
                            </div>
                        </div>
                    }
                    <div className="outside-page-content">
                    	{this.props.children}
                    </div>
                </div>
			</div>
		);
    }
});


// WEBPACK FOOTER //
// ../modules/js/v3/components/outside_page.js